import React from 'react';
import clsx from 'clsx';
import {
  Button, Icon, Popup, Table,
} from 'semantic-ui-react';
import LinkList from '../list/LinkList';

const ListCell = ({
  className,
  items,
  ListComponent = LinkList,
  theme,
}) => (
  <Table.Cell className={clsx('aridhia-list-cell', className)}>
    <ListComponent items={(items || []).slice(0, 3)} className="aridhia-list-cell--list" />
    {items?.length > 3 && (
      <Popup
        position="right center"
        className={`aridhia-theme-${theme}`}
        hoverable
        wide
        content={(<ListComponent items={items} />)}
        trigger={(
          <Button icon size="mini" className="aridhia-list-cell--hover">
            <Icon name="ellipsis horizontal" />
          </Button>
        )}
      />
    )}
  </Table.Cell>
);

export default ListCell;
